import { Client } from '../client/'
class BaseModel {
    constructor() {
        this.apiRoot = 'api'
        this.apiVersion = 'v1'
        this.apiBase = ''
        this._client = new Client()
        this._loading = false
        this._loaded = false
        this.reset()
    }

    get base() {
        return `${this.apiRoot}${this.apiVersion ? `/${this.apiVersion}` : ''}/${this.apiBase}`
    }

    get loaded() {
        return this._loaded
    }

    get loading() {
        return this._loading
    }

    reset() {
        this._loading = false
        this._loaded = false
    }
}

export default BaseModel
